var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_vm._l((_vm.cloumns),function(cloumn){return [(!cloumn.disable)?_c('tableTh',{class:cloumn.supData ? 'sup_data' : '',attrs:{"text":cloumn.title,"sort":cloumn.sort ? cloumn.column : null}}):_vm._e()]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }